<template>
  <b-modal
    v-model="modalOpen"
    centered
    title="تفاصيل النشاط"
    footer-class="removed"
    class="edit-modal"
    id="activityModal"
    no-close-on-backdrop
  >
    <b-card-text>
      <validation-observer ref="activityValidation">
        <b-form @submit.prevent>
          <b-form-row>
            <b-col cols="12">
              <form-select
                label="النشاط"
                v-model="form.plan_activity_id"
                :getOptionLabel="(x) => x.name"
                :reduce="(x) => x.information.id"
                id="activity"
                ep="v2/selects/plan/activities"
                rules="required"
                ref="activity"
              />
            </b-col>
            <b-col cols="12">
              <b-form-group class="checkbox-cont" label="التنفيذ">
                <b-form-checkbox-group
                  id="checkbox-group"
                  v-model="form.months"
                  :options="options"
                  name="execution"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <form-select
                label="الفئات المستهدفة"
                v-model="age_groups"
                :getOptionLabel="(x) => x.name_ar"
                :reduce="
                  (x) => {
                    return { ...x, male: 0, female: 0 };
                  }
                "
                id="ageCat"
                ep="v2/selects/age-groups"
                rules="required"
                ref="ageCat"
                :closeOnSelect="false"
                multiple
              />
            </b-col>
            <b-form-row
              :key="group.id"
              v-for="group in age_groups"
              class="align-items-center px-50"
            >
              <b-col>
                <form-input
                  size="sm"
                  :value="group.name_ar"
                  plaintext
                  id="cat"
                />
              </b-col>
              <b-col>
                <form-input
                  v-model.number="group.male"
                  size="sm"
                  label="ذكور"
                  id="male"
                />
              </b-col>
              <b-col>
                <form-input
                  v-model.number="group.female"
                  size="sm"
                  label="إناث"
                  id="female"
                />
              </b-col>
            </b-form-row>

            <b-form-row class="w-100">
              <b-col>
                <form-input
                  id="beneficiaries_number"
                  label="إجمالي عدد المستفيدين"
                  :description="benNumHint"
                  plaintext
                  :value="benNum"
                  size="sm"
                />
              </b-col>
              <b-col>
                <form-input
                  id="funds"
                  label="الموازنة"
                  v-model.number="form.funds"
                  rules="required"
                  :description="fundsHint"
                  size="sm"
                />
              </b-col>
            </b-form-row>
          </b-form-row>
          <hr />

          <b-row class="px-1 justify-content-end">
            <b-button @click="modalOpen = false" class="mx-1">إلغاء</b-button>
            <save-btn
              @click="saveActivity"
              variant="primary"
              :loading="loading"
              :label="btnLabel"
            >
            </save-btn>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card-text>
  </b-modal>
</template>
<script>
import { required } from "@validations";
import { ValidationObserver } from "vee-validate";

import {
  BRow,
  BFormRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormRadio,
  BForm,
  BFormTextarea,
  BFormCheckbox,
  BFormCheckboxGroup,
  BButton,
} from "bootstrap-vue";
import formSelect from "@/components/form-select";
import formInput from "@/components/form-input";
import saveBtn from "@/components/loader-btn";
import formDatepicker from "@/components/form-datepicker";
import FormInput from "@/components/form-input/index.vue";
const initForm = {
  beneficiaries: [],
  months: [],
  funds: null,
  plan_activity_id: null,
};

export default {
  components: {
    ValidationObserver,
    formInput,
    formSelect,
    BButton,
    BFormRow,
    formDatepicker,
    saveBtn,
    BRow,
    BCol,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BFormGroup,
    BForm,
    BFormRadio,
    BFormTextarea,
    BFormCheckbox,
    BFormCheckboxGroup,
    FormInput,
  },
  props: {
    value: Boolean,
    title: String,
    btnLabel: { type: String, default: () => "حفظ" },
    loading: Boolean,
    intializeForm: {
      type: Object,
      default: () => initForm,
    },
  },
  data() {
    return {
      form: {
        beneficiaries: [],
        months: [],
        funds: null,
        plan_activity_id: null,
      },
      age_groups: [],
      program_id: null,
      selected: [],
      options: [
        { text: "ك 2", value: "1" },
        { text: "شباط", value: "2" },
        { text: "آذار", value: "3" },
        { text: "نيسان", value: "4" },
        { text: "أيار", value: "5" },
        { text: "حزيران", value: "6" },
        { text: "تموز", value: "7" },
        { text: "آب", value: "8" },
        { text: "أيلول", value: "9" },
        { text: "ت 1", value: "10" },
        { text: "ت 2", value: "11" },
        { text: "ك 1", value: "12" },
      ],
      required,
    };
  },
  computed: {
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
    benNumHint() {
      // return "عدد المستفيدين المخطط له 300";
      return "";
    },
    fundsHint() {
      return "";
    },
    benNum() {
      var x = 0;
      this.age_groups.forEach((el) => {
        if (el.male) {
          x += el.male;
        }
        if (el.female) {
          x += el.female;
        }
      });
      return x;
    },
  },
  watch: {
    modalOpen(val) {
      if (val) this.init(this.intializeForm);
    },
    activitiesEp(newVal) {
      if (this.$refs.activity && this.activitiesEp.length > 1)
        this.$refs.activity.refreshOptions(newVal);
    },
  },

  methods: {
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
      this.age_groups = [];
    },
    saveActivity() {
      this.$refs.activityValidation.validate().then((success) => {
        if (success) {
          var benf = [];
          this.age_groups.forEach((el) => {
            benf.push({
              beneficiaries_number: el.male,
              beneficiaries_gender: 0,
              age_group_id: el.id,
            });
            benf.push({
              beneficiaries_number: el.female,
              beneficiaries_gender: 1,
              age_group_id: el.id,
            });
          });
          var toSave = {
            plan_activity_id: this.form.plan_activity_id,
            months: this.form.months,
            funds: this.form.funds,
            beneficiaries: benf,
          };
          this.$emit("confirm", toSave);
        }
      });
    },
  },
};
</script>

<style lang="scss">
.checkbox-cont {
  .bv-no-focus-ring {
    display: grid;
    grid-template-columns: auto auto auto auto;
  }
}
</style>
